import { FC, HTMLAttributes, useEffect, useState } from "react";
import { useStyles } from "./CountdownButton.style";
import { Button } from "@onmo/ui";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { useTranslation } from "react-i18next";

export const CountdownButton: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    if (countdown <= 0) {
      if (countdown === 0) navigate(PageRoutes.Home);
      return;
    }

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [countdown, navigate]);

  return (
    <Button
      onClick={() => {
        navigate(PageRoutes.Home);
      }}
      className={classes.countdownButton}
      fullWidth
      size="large"
      variant="outlined"
    >{`${t("common_Homepage")} (${countdown})`}</Button>
  );
};

export default CountdownButton;
